import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <p className="footer-links">
        <strong>ContactNo / Whatsapp order: +918248192299</strong>        <span><strong> / </strong></span>
        <a href="mailto:akshophub@gmail.com" target="_blank">
        <strong>         EmailID: akshophub@gmail.com</strong>
 
        </a>
      </p>
      <p>
        &copy; {currentYear} <strong>Ak Crackers Shop - Quality is our pride - GSTIN 33AFXPR4508N1ZO </strong>
      </p>
    </footer>
  );
};

export default Footer;
